import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GetChecklistPayload, ChecklistInbound, SavedDraftProtocol } from '@models/*';
import { RestService } from '../../core/services/rest.service';
import { ErrorService } from '../../core/services/error.service';
import { NetworkService } from '../../core/services/network.service';
import { APP_CONFIG, AppConfig } from '../../config/app-config';

@Injectable()
export class ChecklistService extends RestService {
  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    http: HttpClient,
    errorService: ErrorService,
    networkService: NetworkService,
    injector: Injector,
  ) {
    super(appConfig, http, errorService, networkService, injector);
  }

  getChecklist(payload: GetChecklistPayload): Observable<ChecklistInbound | SavedDraftProtocol> {
    const { tourStopActionId, forPrecedingTransport } = payload;
    let endpoint = `${this.CHECKLIST_URL}?tourStopActionId=${tourStopActionId}`;
    if ('forPrecedingTransport' in payload) {
      endpoint += `&forPrecedingTransport=${forPrecedingTransport}`;
    }

    return this.get(endpoint, null, true).pipe(
      map((res) => (res instanceof HttpErrorResponse || res.error ? null : res.data))
    );
  }
}
